module.exports = __webpack_public_path__ + "img/student-logo.ad06000d.png";